
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface SidebarFooterProps {
  language: Language;
  onOpenPlans: () => void;
  onSwitchLanguage: (lang: Language) => void;
  onOpenSettings: () => void;
  onLogout: () => void;
  onClose: () => void;
}

const SidebarFooter: React.FC<SidebarFooterProps> = ({ 
  language, onOpenPlans, onSwitchLanguage, onOpenSettings, onLogout, onClose 
}) => {
  const t = TRANSLATIONS[language];
  
  return (
    <div className="p-4 lg:p-5 bg-slate-50 dark:bg-white/[0.01] border-t border-slate-50 dark:border-white/5 space-y-2 lg:space-y-3">
      <button 
        onClick={() => { onOpenPlans(); onClose(); }} 
        className="w-full flex items-center justify-center gap-2 py-3.5 bg-amber-500 text-white text-[10px] font-black rounded-xl shadow-md hover:scale-[1.02] active:scale-95 transition-all"
      >
        <i className="fas fa-crown"></i>{t.upgrade}
      </button>
      
      <div className="grid grid-cols-2 gap-2">
        <button 
          onClick={() => onSwitchLanguage(language === 'ar' ? 'en' : 'ar')} 
          className="flex items-center justify-center gap-2 py-3 rounded-xl bg-white dark:bg-white/5 border border-slate-200 dark:border-white/5 text-[9px] font-black text-slate-600 dark:text-slate-400 hover:bg-slate-50 transition-all"
        >
          <i className="fas fa-globe text-emerald-500"></i>
          {language === 'ar' ? 'English' : 'العربية'}
        </button>
        <button 
          onClick={() => { onOpenSettings(); onClose(); }} 
          className="flex items-center justify-center gap-2 py-3 rounded-xl bg-white dark:bg-white/5 border border-slate-200 dark:border-white/5 text-[9px] font-black text-slate-600 dark:text-slate-400 hover:bg-slate-50 transition-all"
        >
          <i className="fas fa-gear text-emerald-500"></i>{t.settings}
        </button>
      </div>
      
      <button 
        onClick={() => { onLogout(); onClose(); }} 
        className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-rose-500/5 border border-rose-500/10 text-[9px] font-black text-rose-500 hover:bg-rose-500 hover:text-white transition-all"
      >
        <i className="fas fa-right-from-bracket"></i>{t.logout}
      </button>
    </div>
  );
};
export default SidebarFooter;
